/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractTemplatesList_stateTypes$ref: FragmentReference;
declare export opaque type ContractTemplatesList_stateTypes$fragmentType: ContractTemplatesList_stateTypes$ref;
export type ContractTemplatesList_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ContractTemplatesList_stateTypes$ref,
|};
export type ContractTemplatesList_stateTypes$data = ContractTemplatesList_stateTypes;
export type ContractTemplatesList_stateTypes$key = {
  +$data?: ContractTemplatesList_stateTypes$data,
  +$fragmentRefs: ContractTemplatesList_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContractTemplatesList_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f74f366a2fcc924fe86453711c392200';
module.exports = node;
